'use strict';

var Social = function(config) {
  var self = this;
  var $el = $(config.el);

  self.parseItems = function() {
    var $items = $el.find('li');
    $items.each(function() {
      var $this = $(this);
      var $link = $this.find('a');
      var iconName = $link.text().toLowerCase();
      var $icon = $(config.template(iconName));

      $link.wrapInner('<span class="text"></span>');
      $link.append($icon);
    })
  }

  self.init = function() {
    self.parseItems();
  }
};

module.exports = Social;
